import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import es from './locales/es';
import en from './locales/en';
import ca from './locales/ca';
import gl from './locales/gl';
import eu from './locales/eu';

const savedLanguage = localStorage.getItem('appLanguage') || 'es';

const resources = {
    es: { translation: es },
    en: { translation: en },
    ca: { translation: ca },
    gl: { translation: gl },
    eu: { translation: eu },
};

i18n.use(initReactI18next).init({
    resources,
    lng: savedLanguage,
    fallbackLng: 'es',
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;